import { Injectable } from '@angular/core';
import { FrontEndLoggerService } from '@core/front-end-logger';

@Injectable({
  providedIn: 'root',
})
export class WebVitalsService {
  constructor(private feLogger: FrontEndLoggerService) {
    this.init();
  }

  private init() {
    if (typeof window === 'undefined') {
      return;
    }

    try {
      // Dynamically import to avoid build issues if web-vitals is unavailable
      import('web-vitals')
        .then(webVitals => {
          const send = (metric: any) => {
            const payload: any = {
              name: metric.name,
              id: metric.id,
              value: metric.value,
              delta: metric.delta,
              rating: metric.rating,
              startTime: metric.startTime,
              attribution: metric.attribution,
            };

            // send to FrontEndLoggerService as a performance event
            this.feLogger.logPerformance({ metric: payload });
          };

          // register available metrics (web-vitals v3+ API)
          if (webVitals.onCLS) webVitals.onCLS(send);
          if (webVitals.onFCP) webVitals.onFCP(send);
          if (webVitals.onINP) webVitals.onINP(send);
          if (webVitals.onLCP) webVitals.onLCP(send);
          if (webVitals.onTTFB) webVitals.onTTFB(send);
        })
        .catch(error => {
          // package not available or failed to load — graceful fallback
          console.warn('Web Vitals: unable to load web-vitals library', error);
          this.feLogger.logPerformance({
            message: 'Error during web-vitals',
            error,
          });
        });
    } catch (error) {
      console.warn('Web Vitals: error initializing', error);
      this.feLogger.logPerformance({
        message: 'Error during web-vitals',
        error,
      });
    }
  }
}
